import { Icon, IconProps } from "@chakra-ui/react";

const MobileIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 83 157" {...props}>
      <rect width="83" height="157" rx="13" fill="white" />
      <circle cx="42" cy="135" r="9" fill="#101010" />
    </Icon>
  );
};

export default MobileIcon;
